<template>
  <b-input-group>
    <flat-pickr
      ref="flatpickr"
      :id="pickerId"
      :value="value"
      :config="flatpickrConfig"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{ 'flat-pickr': true, 'form-control': true, ... withClass }"
      @input="(dates) => $emit('input', dates)"
      @on-change="(dates) => $emit('on-change', dates)"
    />
    <b-input-group-append
      class="flatpickr-icon-container"
      :readonly="disabled"
      @click="openFlatpickr"
    >
      <i class="si si-calendar" />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { uniqueId as _uniqueId } from 'lodash';
export default {
  name: 'DateRangePicker',
  props: {
    id: {
      type: String,
    },
    value: {
      type: [Array, String],
    },
    withClass: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    static: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
    }
  },
  data() {
    return {
      flatpickrConfig: { mode: 'range', dateFormat: 'M j, Y', static: this.static, clickOpens: !this.disabled },
      pickerId: this.id || `sfs-date-range-picker-${_uniqueId()}`,
    };
  },
  methods: {
    openFlatpickr() {
      const fp = this.$refs.flatpickr?.fp;
      if (!this.disabled && fp && typeof fp.open === 'function') {
        fp.open();
      }
    }
  },
};
</script>
